import compose from 'lodash/flowRight'

import { withAnalytics } from '../AssignRetailerAccountModal.analytics'
import AssignRetailerAccountModal from '../AssignRetailerAccountModal.component'
import { withRedux } from '../AssignRetailerAccountModal.container'
import withUpdateOrderRetailerAccountMutation from '../AssignRetailerAccountModal.mutations'
import { withPublicRetailers } from '../AssignRetailerAccountModal.queries'

export default compose(
  withRedux,
  withPublicRetailers,
  withUpdateOrderRetailerAccountMutation,
  withAnalytics,
)(AssignRetailerAccountModal)
